import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatChipInputEvent } from '@angular/material/chips';
import { NgxSpinnerService } from 'ngx-spinner';
import { Observable, map, startWith } from 'rxjs';
import { HTTPService } from 'src/app/services/http.service';
import { ObjectUtil } from 'src/app/system-utils/utils/ObjectUtil';
import {LiveAnnouncer} from '@angular/cdk/a11y';
import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { FormArrayConfiguration } from 'src/app/system-utils/form-array-component/form-array-component.component';
import { ThemeService } from 'src/app/services/theme.service';

@Component({
    selector: 'sankhya-instance',
    templateUrl: './sankhya-instance.component.html',
    styleUrls: ['./sankhya-instance.component.scss'],
    standalone: false
})
export class SankhyaInstanceComponent implements OnInit {
  returnValueConfiguration:FormArrayConfiguration[] = [];

  constructor(private formBuilder:FormBuilder, 
              private announcer:LiveAnnouncer,
              private http:HTTPService, 
              private cd:ChangeDetectorRef,
              private spinner:NgxSpinnerService,
              public ThemeService:ThemeService) { }

  destinos: string[] = ['One', 'Two', 'Three'];
  destinoFilteredOptions: Observable<string[]>;
  validationQueryFieldsList = [];
  separatorKeysCodes: number[] = [ENTER, COMMA];
  selectable = true;  
  validationFormFields:FormControl<string> = new FormControl();
  formGroup:FormGroup<any>;
  
  async ngOnInit(): Promise<void> {
  
    this.spinner.show('sankhyainstance');

    this.formInitialize();

    this.formGroup = this.formBuilder.group({
        origem: new FormControl<string>(null,Validators.required),
        type: new FormControl<string>('finder',Validators.required),
        filter: new FormControl<string>(null,Validators.required),
        innerArray: new FormControl<string|null>(null),
        innerArrayBody: new FormControl<string|null>('BODY'),
        execOrder: new FormControl<number|null>(-999), //more Options
        destino: new FormControl<string>(null,Validators.required), // feito
        entityToJson: new FormControl<boolean>(false), //more Options
        body: new FormControl<string|null>('BODY'), //more Options
        successStatus: new FormControl<string|null>('1'), // not show
        joinFields: new FormControl<string|null>(null), ////more Options
        validationQuery: new FormControl<string|null>(null),
        validationQueryFields: new FormControl<string|null>(null),
        validationQueryCondition: new FormControl<string|null>(null),
        useCustomValidationQuery: new FormControl<boolean|null>(false),
        customValidationQuery: this.formBuilder.array([{
          serviceName: new FormControl<string|null>(null,Validators.required),
          isJson: new FormControl<boolean>(false),
          validationQuery:new FormControl<string|null>(null,Validators.required),
          name:new FormControl<string|null>(null,Validators.required),
          errorStatus:new FormControl<string|null>(null),
          mensagem:new FormControl<string|null>(null),
          returnField:this.formBuilder.array([{
            field:new FormControl<string|null>(null),
            returnFormula:new FormControl<string|null>(null),
            path:new FormControl<string|null>(null)
          }])
        }]),
        groupBy: new FormControl<string|null>(null),
        returnField:this.formBuilder.array([/*{
            field:new FormControl<string|null>(null),
            returnFormula:new FormControl<string|null>(null),
            path:new FormControl<string|null>(null)
        }*/]),
        data:this.formBuilder.group({
            child:this.formBuilder.group({
               type: new FormControl<string|null>(null),
               pathQuery: new FormControl<string|null>(null),
               query: new FormControl<string|null>(null),
               recursive: new FormControl<string|null>(null),
               validation: new FormControl<string|null>(null),
               usaNewJson: new FormControl<boolean|null>(null),
               usaNewXml: new FormControl<boolean|null>(null),
               useLocalQuery:new FormControl<boolean|null>(true),
               recursiveFatherFields:this.formBuilder.array([{
                  path:new FormControl<string|null>(null),
                  newTag:new FormControl<string|null>(null),
               }])
            }),
            arrayMother: this.formBuilder.array([{
              origem:new FormControl<string|null>(null,Validators.required),
              mapOrigem:new FormControl<string|null>(null),
              mapOrigemFormula:new FormControl<string|null>(null),
              destino:new FormControl<string|null>(null,Validators.required),
              returnField:this.formBuilder.array([{
                field:new FormControl<string|null>(null),
                returnFormula:new FormControl<string|null>(null),
                path:new FormControl<string|null>(null)
              }]),
              usaNewJson:new FormControl<boolean|null>(false),
              isJson:new FormControl<boolean|null>(false),
              validationQuery:new FormControl<string|null>(null),
              validationQueryPar:this.formBuilder.array([{
                  path:new FormControl<string|null>(null),
                  formula:new FormControl<string|null>(null),
                  usaNewXml:new FormControl<boolean|null>(false),
                  parameterName:new FormControl<string|null>(null,Validators.required),
              }]),
              action:new FormControl<string|null>("create"),
              execOrder:new FormControl<number|null>(-999),
              fromToName:new FormControl<string|null>(null),
            }])
        }),
        doValidation: new FormControl<boolean>(true),
        queryLoad: new FormControl<string|null>(null),
      });


      await this.getDestino().then(d=>{
        setTimeout(()=>{
          this.destinoFilteredOptions = this.formGroup.get('destino').valueChanges.pipe(
            startWith(''),
            map(value => this._filter(value || '')),
          );
        });
        this.spinner.hide('sankhyainstance');
      });

      this.formGroup.get('validationQuery').valueChanges.subscribe(data=>{
          if( data ){
            let destino = this.formGroup.get('destino').value;
            if ( ObjectUtil.isNotEmpty(destino)){
              this.applyMascara(data,destino,null);
            }
            
          }
      })

      
  }
  
  formInitialize() {
  
    this.returnValueConfiguration = [
      {
        name:'field',
        description: 'Nome do Campo de Retorno',
        title:'Campo de Retorno',
        tooltip:'Informar o campo de retorno. O sistema criará uma variavel @NOME_DO_FIELD para usar em qualquer lugar da integração.',
        type:'string'
      },
      {
        name:'returnFormula',
        description: 'Fórmula para Retorno do Campo',
        title:'Fórmula',
        tooltip:'Informar a fórmula de tratamento do retorno',
        type:'formula'
      },
      {
        name:'path',
        description: 'Caminho de Retonro',
        title:'Caminho de Retorno',
        tooltip:'Informar o Caminho de Retorno da Informação',
        type:'string'
      }
    ] 
  }


  applyMascara(data: any, destino:string, fields:string) {
      let newValue = "";
      newValue = `  <entity name="${destino}">      
                      <literalCriteria>          
                        <expression>${data}</expression>      </literalCriteria>
                  `;
      if ( ObjectUtil.isNotEmpty('fields')){
          newValue = newValue + `<fields>          
                                  <field name="ID"/>          
                                  <field name="CODPROD"/>          
                                  <field name="IDVAR"/>          
                                  <field name="IDTRAY"/>      
                                </fields> `;
      }      
                      
      newValue = newValue + `</entity>`;
  }

  private _filter(value: string): string[] {
    const filterValue = value.toLowerCase();
    return this.destinos.filter(option => option['NAME'].toLowerCase().includes(filterValue));
  }

  getDestino(){
    let buscaName = {
      "entityName":"Mktpcfg",
      "sql":`SELECT DISTINCT 
                      CASE 
                      WHEN ISJSON(EXPRESSION)=1 THEN  JSON_VALUE(EXPRESSION,'$.destino') 
                      ELSE NULL 
                      END NAME 
              FROM MKTPCFI 
              WHERE SERVICETYPE='5'
              AND CASE WHEN ISJSON(EXPRESSION)=1 THEN  JSON_VALUE(EXPRESSION,'$.destino') 
                       ELSE NULL 
                  END  NOT LIKE 'AD_%'
              ORDER BY 1`            
    };

    let self = this;
    return new Promise((resolve,reject)=>{
      this.http.post(buscaName,'JsonBrokerServices/findnative',false,true,true).subscribe(con=>{
                  
          if( ObjectUtil.isNotEmpty(con['SQL'])){
            self.destinos  = con['SQL'];        
            resolve(true);
          }
        });
    })
    
  }

  addChip(event: MatChipInputEvent): void {
    const value = (event.value || '').trim();

    // Add our fruit
    if (value) {
      this.validationQueryFieldsList.push(value);
    }

    // Clear the input value
    event.chipInput!.clear();

    this.validationFormFields.setValue(null);
  }

  removeChip(field: string): void {
    const index = this.validationQueryFieldsList.indexOf(field);

    if (index >= 0) {
      this.validationQueryFieldsList.splice(index, 1);

      this.announcer.announce(`Removed ${field}`);
    }
  }

  validationQueryCreator(entityName:string,condition:string, fields:string){
    let f = "";
    fields.split('\,');
    for  ( var field of fields){
      f+= `<field name=\"${field}\"/>`;
    }

    return `<entity name=\\"${entityName}\\">
      <literalCriteria>
        <expression>${condition}</expression>
      </literalCriteria>
      <fields>
        ${f}
      </fields>
    </entity>`;

  
  }
  
}
